var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "materials"
  }, [_c("a-alert", {
    attrs: {
      message: "*" + _vm.$t("请确认") + _vm.$t("根据指引提交相应理赔材料"),
      banner: ""
    }
  }), _c("a-form-model", {
    ref: "addFormRef",
    attrs: {
      model: _vm.submitInfo,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_vm._l(_vm.submitInfo.claimsDocument, function (item, index) {
    return _c("a-form-model-item", {
      key: index,
      attrs: {
        label: item.documentName
      }
    }, [_c("a-upload", {
      staticClass: "upload-list-inline",
      attrs: {
        action: _vm.action,
        accept: _vm.uploadAccept,
        remove: file => _vm.removeUploadFile(file, index),
        "open-file-dialog-on-click": _vm.fileDialog,
        "file-list": item.documentUrl,
        "list-type": "picture-card",
        data: {
          module: "claims"
        },
        showUploadList: {
          showPreviewIcon: true,
          showRemoveIcon: true
        },
        headers: {
          "X-Dispatch": "Upload",
          "X-Version": "upload"
        }
      },
      on: {
        preview: file => _vm.handlePreview(file, index),
        change: file => _vm.changeUpload(file, index)
      }
    }, [_c("a-icon", {
      attrs: {
        type: "plus"
      },
      on: {
        click: function ($event) {
          return _vm.clickPlus(index);
        }
      }
    })], 1), item.documentDescription ? _c("label", {
      staticClass: "font"
    }, [_vm._v("*" + _vm._s(item.documentDescription))]) : _vm._e(), _c("label", {
      staticClass: "font"
    }, [_vm._v(" *" + _vm._s(_vm.$t("文件格式")) + "（" + _vm._s(item.documentFormat.join(",")) + "） "), item.documentTemplateUrl.length != 0 ? _c("span", {
      staticClass: "modal-preview",
      on: {
        click: function ($event) {
          return _vm.onModalPreview(index);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("模板预览")))]) : _vm._e()])], 1);
  }), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("材料补充")
    }
  }, [_c("a-upload", {
    staticClass: "upload-list-inline",
    attrs: {
      action: _vm.action,
      accept: _vm.uploadAccept,
      remove: file => _vm.removeUploadFile(file),
      "open-file-dialog-on-click": _vm.fileDialog,
      "file-list": _vm.additionalFileList,
      "list-type": "picture-card",
      data: {
        module: "claims"
      },
      showUploadList: {
        showPreviewIcon: true,
        showRemoveIcon: true
      },
      headers: {
        "X-Dispatch": "Upload",
        "X-Version": "upload"
      }
    },
    on: {
      preview: file => _vm.handlePreview(file),
      change: file => _vm.changeUpload(file)
    }
  }, [_c("a-icon", {
    attrs: {
      type: "plus"
    },
    on: {
      click: function ($event) {
        return _vm.clickPlus("addition");
      }
    }
  })], 1), _c("label", {
    staticClass: "font"
  }, [_vm._v(" *" + _vm._s(_vm.$t("文件格式")) + "（" + _vm._s(_vm.plainOptions.join(",")) + "） ")])], 1), _c("a-form-model-item", {
    attrs: {
      "wrapper-col": {
        span: 10,
        offset: 4
      }
    }
  }, [_c("a-button", {
    staticClass: "marginR15",
    on: {
      click: function ($event) {
        return _vm.$emit("back");
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("上一步")))]), _c("a-button", {
    attrs: {
      type: "primary",
      loading: _vm.loading
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t("提交")))])], 1)], 2), _c("preview-list-modal", {
    attrs: {
      previewVisible: _vm.previewListVisible,
      fileList: _vm.modalPreviewList
    },
    on: {
      cancel: function ($event) {
        _vm.previewListVisible = false;
      }
    }
  }), _c("preview-modal", {
    attrs: {
      visible: _vm.previewVisible,
      videoTypeList: ["avi", "mov", "rm", "mp4", "rmvb"],
      fileList: _vm.previewFileList,
      show: _vm.isShow,
      src: _vm.previewSrc,
      currentIndex: _vm.currentPreviewIndex
    },
    on: {
      cancel: function ($event) {
        _vm.previewVisible = false;
      }
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };